import React from 'react';
import ReactDOM from 'react-dom';


var keyAndPossibleValueStyle =
{
   margin: '0 0 10px 0',
   minWidth: 70,
   verticalAlign:'top',
   display:'block',
}

var keyAndPossibleValueStyleFinal =
{
   minWidth: 70,
   verticalAlign:'top',
   display:'block',
}

var valueCollectionStyle=
{
   minWidth: 71,
   
   verticalAlign:'top',
   display:'inline-block',
}

var keyStyle=
{
    minWidth: 100,
   
   display:'inline-block',
}

var valueStyle=
{
    minWidth: 73,
   
   display:'inline-block',
}

class RecursiveField extends React.Component {
   constructor(props)
   {
      super(props);
      this.state = new Object();
      
   }

   componentDidMount()
   {
     
   }





   render()
   {
      var elemKeys = [];

      var isFinalValue = typeof this.props.elemVal === 'number' || typeof this.props.elemVal === 'string';
     
      for(var key in this.props.elemVal)
      {
         elemKeys.push(key);
         //var val = this.props.elem[key];
         //console.log("Key: " + key + " val: " + val);
      }

      var keyCount = elemKeys.length;

      return (
         <div style={isFinalValue ? keyAndPossibleValueStyleFinal : keyAndPossibleValueStyle}>
            <div style={keyStyle}> {this.props.elemKey}:</div>
            
            {isFinalValue ? <div style={valueStyle}> {this.props.elemVal} </div> :
            <div style={valueCollectionStyle} > 
               {elemKeys.map((k, i) =>
                  <RecursiveField key ={i} elemKey={k} elemVal={this.props.elemVal[k]}/>)}
            </div>}
         </div>
     );
   }
}


class RecursiveTable extends React.Component {
   constructor(props)
   {
      super(props);
      this.state = new Object();
      
   }

   componentDidMount()
   {
     
   }





   render()
   {
      var isFinalValue = typeof this.props.elem === 'number' || typeof this.props.elem === 'string';
     
      var elemKeys = [];

      for(var key in this.props.elemVal)
      {
         elemKeys.push(key);
         //var val = this.props.elem[key];
         //console.log("Key: " + key + " val: " + val);
      }

      var keyCount = elemKeys.length;

      return (
         <div style={isFinalValue ? keyAndPossibleValueStyleFinal : keyAndPossibleValueStyle}>
            {elemKeys.map((k, i) =>
               <RecursiveField key ={i} elemKey={k} elemVal={this.props.elem[k]}/>)}
         </div>
     );
   }
}
export default RecursiveTable;


// WEBPACK FOOTER //
// ./js/RecursiveField.jsx